import { Portal, Box, useDisclosure } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import React, { useEffect, useState } from "react";

import Navbar from "components/navbar/NavbarAdmin.js";
import Sidebar from "components/sidebar/Sidebar.js";
import { SidebarContext } from "contexts/SidebarContext";
import routes from "routes.js";
import Footer from "components/footer/FooterAdmin.js";
import ToastNotification from "components/modals/ToastNotification";
import withAuthentication from "components/wrappers/withAuthentication";
import { loggedInUserState } from "atoms/loggedInUserState";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { tenantDetailsState } from "atoms/tenantDetails";
import useAxios from "axios-hooks";

// Custom Chakra theme
const Dashboard = (props) => {
  const { ...rest } = props;
  // states and functions
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  // functions for changing the states from components

  const loggedInUser = useRecoilValue(loggedInUserState);
  const setTenantDetails = useSetRecoilState(tenantDetailsState);

  const [{ data: dataTool, loading, error }, execute, cancel] = useAxios(
    {
      url: `/api/tenant/${loggedInUser?.tenantId}`,
      method: "GET",
    },
    {
      manual: true,
    }
  );

  async function fetchTenantDetails() {
    try {
      const res = await execute();
      if (res?.data) {
        setTenantDetails(res?.data?.data);
      }
    } catch (error) {
      console.log(error);
      setTenantDetails(null);
    }
  }

  const getActiveRoute = (routes) => {
    let activeRoute = "";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
        //    else if (window.location.href.indexOf("admin/tenant") !== -1) {
        //   return "Account Settings";
        // }
      }
    }
    return activeRoute;
  };

  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    // for (let i = 0; i < routes.length; i++) {
    //   if (routes[i].collapse) {
    //     let collapseActiveNavbar = getActiveNavbar(routes[i].items);
    //     if (collapseActiveNavbar !== activeNavbar) {
    //       return collapseActiveNavbar;
    //     }
    //   } else if (routes[i].category) {
    //     let categoryActiveNavbar = getActiveNavbar(routes[i].items);
    //     if (categoryActiveNavbar !== activeNavbar) {
    //       return categoryActiveNavbar;
    //     }
    //   } else {
    //     if (
    //       window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
    //     ) {
    //       return routes[i].secondary;
    //     }
    //   }
    // }
    return activeNavbar;
  };

  const getActiveNavbarText = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbarText(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbarText(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].messageNavbar;
        }
      }
    }
    return activeNavbar;
  };

  // document.documentElement.dir = "ltr";
  const { onOpen } = useDisclosure();
  // document.documentElement.dir = "ltr";

  useEffect(() => {
    if (loggedInUser?.tenantId && !tenantDetailsState) {
    }
  }, [loggedInUser]);

  return (
    <Box>
      <Box>
        <SidebarContext.Provider
          value={{
            toggleSidebar,
            setToggleSidebar,
          }}
        >
          <Sidebar routes={routes} display="none" {...rest} />
          <Box
            float="right"
            minHeight="100vh"
            height="100%"
            overflow="auto"
            position="relative"
            maxHeight="100%"
            w={{ base: "100%", xl: "calc( 100% - 290px )" }}
            maxWidth={{ base: "100%", xl: "calc( 100% - 290px )" }}
            transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
            transitionDuration=".2s, .2s, .35s"
            transitionProperty="top, bottom, width"
            transitionTimingFunction="linear, linear, ease"
          >
            <Portal>
              <Box>
                <Navbar
                  onOpen={onOpen}
                  logoText={"..."}
                  brandText={getActiveRoute(routes)}
                  secondary={getActiveNavbar(routes)}
                  message={getActiveNavbarText(routes)}
                  fixed={fixed}
                  {...rest}
                />
              </Box>
            </Portal>
            <Box
              mx="auto"
              p={{ base: "12px", sm: "16px", md: "24px", lg: "30px" }}
              pe={{ base: "12px", sm: "16px", md: "20px" }}
              minH="100vh"
              pt={{ base: "40px", md: "30px", xl: "50px" }}
            >
              <Outlet />
              <ToastNotification />
            </Box>

            <Box>
              <Footer />
            </Box>
          </Box>
        </SidebarContext.Provider>
      </Box>
    </Box>
  );
};

export default withAuthentication(Dashboard);
